module.exports = __webpack_public_path__ + "img/study.1b731dd0.svg";